import videoCallVF from "views/resources/gifs/videocall-vf.gif";
import videoCallAFP from "views/resources/gifs/call-afp-habitat.gif";
import videoCall from "views/resources/gifs/video-call.gif";
import zeroQLogo from "views/resources/logos/SVG/simple-logo.svg";
import vfLogo from "views/resources/logos/SVG/33.svg";
import vfGreenLogo from "views/resources/logos/SVG/vf-green.svg";
import vfWhiteLogo from "views/resources/logos/SVG/vf-white.svg";
import zeroqBlue from "views/resources/logos/SVG/zeroq.svg";
import zeroqWhite from "views/resources/logos/SVG/zeroq-white.svg";
import afpHabitatLogo from "views/resources/logos/SVG/afp-habitat.svg";
import afpHabitatWhiteLogo from "views/resources/logos/SVG/afp-habitat-white.svg";

export const waitingRoomThemes = {
	"viajes-falabella": {
		gif: videoCallVF,
		infoIconBackgroundColor: "#F1F5E4",
		infoIconColor: "#3FAE2B",
		yourTurnBackgroundColor: "#75AC40",
		headerIcon: vfLogo,
		iconSize: "big",
		queueInfoLogo: vfGreenLogo,
		yourTurnLogo: vfWhiteLogo,
	},
	"afp-habitat": {
		gif: videoCallAFP,
		infoIconBackgroundColor: "rgba(206, 19, 54, 0.1)",
		infoIconColor: "#CE1336",
		yourTurnBackgroundColor: "#C90934",
		headerIcon: afpHabitatLogo,
		iconSize: "big",
		queueInfoLogo: afpHabitatLogo,
		yourTurnLogo: afpHabitatWhiteLogo,
	},
	zeroq: {
		gif: videoCall,
		infoIconBackgroundColor: "#E6EAFC",
		infoIconColor: "#002EFF",
		yourTurnBackgroundColor: "#2242E4",
		headerIcon: zeroQLogo,
		iconSize: "regular",
		queueInfoLogo: zeroqBlue,
		yourTurnLogo: zeroqWhite,
	},
};
